import React, { useContext, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import { useIntl } from 'react-intl';
import { GaIcon } from '@luigiclaudio/ga-baseline-ui/icon';
import { buttonSkinData } from '@luigiclaudio/ga-baseline-ui/button';
import ColorTooltipSelectionActionButton from './ColorTooltipSelectionActionButton';

const ColorTooltipSelectionAction = forwardRef(({ colorValue, skin, disabled, ...props }, ref) => {
    const theme = useContext(ThemeContext);
    const intl = useIntl();

    return (
        <ColorTooltipSelectionActionButton
            ref={ref}
            skin={skin}
            disabled={disabled}
            aria-label={intl.formatMessage(
                {
                    id: 'colorTooltip.select.button.label',
                },
                { colorValue },
            )}
            {...props}
        >
            <GaIcon icon="more-vertical" size={theme.button.iconSize.default} />
        </ColorTooltipSelectionActionButton>
    );
});

ColorTooltipSelectionAction.propTypes = {
    skin: PropTypes.oneOf(buttonSkinData),
    disabled: PropTypes.bool,
    colorValue: PropTypes.string,
};

ColorTooltipSelectionAction.defaultProps = {
    skin: 'primary',
    disabled: false,
    colorValue: undefined,
};

export default ColorTooltipSelectionAction;
